import { Component, OnInit, Inject, ViewChild, TemplateRef, OnDestroy, ElementRef } from '@angular/core';
import { TranslationService } from '../../common/services/translation.service';
import { DataTableFilter, FilterType, FilterOperator, RowChanges } from '../../common/models/DataTableFilter.model';
import { IColumn, CellType } from '../../common/interfaces/IColumn.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProductTableRow } from '../../../product-module/products-data-table/product-data-table-row.model';
import { SpinnerService } from '../../../app-module/spinner/spinner.service';
import { ProductsDataTableService } from '../../../product-module/products-data-table/products-data-table.service';
import { ProductDataTableData } from './product-data-table-data.model';
import { IPagedDataTable } from '../../common/interfaces/IPagedDataTable.interface';

@Component({
    selector: 'cpq-product-data-table-dialog',
    templateUrl: './cpq-product-data-table-dialog.component.html',
    styleUrls: ['./cpq-product-data-table.component.scss'],
    providers: [ProductsDataTableService],
    standalone: false
})
export class CpqProductDataTableDialogComponent implements OnInit, OnDestroy {
  public filter: DataTableFilter;
  public totalCount: number;
  public columns = new Array<IColumn>();
  public guid: string;
  private selectedProducts = new Array<ProductTableRow>();
  @ViewChild('selectTmpl', { static: true }) selectTmpl: TemplateRef<any>;
  @ViewChild('productDataTableDialog', { static: true }) dialog: ElementRef;

  constructor(
    public service: ProductsDataTableService,
    private translateService: TranslationService,
    public spinnerService: SpinnerService,
    @Inject(MAT_DIALOG_DATA) public productDataTableData: ProductDataTableData | any,
    public dialogRef: MatDialogRef<CpqProductDataTableDialogComponent>) {
  }

  ngOnInit() {
    this.initColumns();
    this.initFilter();
    this.validateGuid(this.productDataTableData.guid);
    this.guid = this.productDataTableData.guid;
  }

  private initFilter() {
    this.filter = new DataTableFilter();
    this.filter.placeholder = 'Admin.PSW.ProductTable.QuickSearch';
    this.filter.totalCountPlaceholder = 'Admin.ProductList.TotalProducts';
    this.filter.filters.push({
      name: 'name',
      value: this.productDataTableData && this.productDataTableData.name ? this.productDataTableData.name : ''
    }, {
        name: 'partNumber',
        value: this.productDataTableData && this.productDataTableData.partNumber ? this.productDataTableData.partNumber : ''
      }, {
        name: 'description',
        value: this.productDataTableData && this.productDataTableData.description ? this.productDataTableData.description : ''
      }, {
        name: 'active',
        type: FilterType.Select,
        value: this.productDataTableData && this.productDataTableData.isActive ? '1' : ''
      }, {
        name: 'isSimple',
        type: FilterType.Select,
        value: this.productDataTableData && this.productDataTableData.isSimple ? '0' : ''
      });
    if (this.productDataTableData && this.productDataTableData.simpleProductReplacementPicker) {
      this.filter.filters.push({
        name: 'simpleProductReplacementPicker',
        type: FilterType.Number,
        value: this.productDataTableData.simpleProductReplacementPicker
      });
    }
    if (this.productDataTableData && this.productDataTableData.referenceProductPicker) {
      this.filter.filters.push({
        name: 'referenceProductPicker',
        type: FilterType.Number,
        value: 'true'
      });
    }
    if (this.productDataTableData && this.productDataTableData.hideSBProducts) {
      this.filter.filters.push({
        name: 'orderItemType',
        type: FilterType.Number,
        operator: FilterOperator.NotEqual,
        value: '2'
      });
    }
    if (this.productDataTableData && this.productDataTableData.productIdsCsv) {
      this.filter.filters.push({
        name: 'product_id',
        operator: FilterOperator.NotIn,
        value: this.productDataTableData.productIdsCsv
      });
    }
    if (this.productDataTableData && this.productDataTableData.excludedProductTypesCsv) {
      this.filter.filters.push({
        name: 'excludedProductTypesCsv',
        value: this.productDataTableData.excludedProductTypesCsv
      });
    }
    if (this.productDataTableData && this.productDataTableData.excludeProductsWithVariantConfigurationType) {
      this.filter.filters.push({
        name: 'configurationType',
        type: FilterType.Number,
        operator: FilterOperator.NotEqual,
        value: '1'
      });
    }
  }

  private initColumns() {
    this.columns = [
      {
        cellTemplate: this.productDataTableData && this.productDataTableData.isMultiSelect ? null : this.selectTmpl,
        cellType: this.productDataTableData && this.productDataTableData.isMultiSelect ? CellType.checkbox : CellType.custom,
        name: this.translateService.translate('Admin.AddEditUserType.SelectProduct'),
        prop: 'selected',
        editable: true,
        visible: true,
        sortable: false
      },
      {
        prop: 'name',
        name: this.translateService.translate('xsltName'),
        visible: true
      },
      {
        prop: 'partNumber',
        name: this.translateService.translate('Admin.PSW.Step1.PartNumber'),
        visible: true
      },
      {
        prop: 'type',
        name: this.translateService.translate('Admin.MLDictionaries.Type'),
        visible: true
      },
      {
        prop: 'category',
        name: this.translateService.translate('Admin.PSW.Step1.Category'),
        visible: true,
        resizeable: true
      },
      {
        prop: 'displayType',
        name: this.translateService.translate('Admin.PSW.DisplayType'),
        visible: true
      },
      {
        prop: 'description',
        name: this.translateService.translate('xsltDescription'),
        visible: true
      },
      {
        prop: 'modifiedDate',
        name: this.translateService.translate('ProductList.DateModified'),
        visible: true
      }
    ];
  }

  private validateGuid(guid: string) {
    if (!guid) {
      throw new RangeError('You can not provide empty guid');
    }
  }

  ngOnDestroy() {
  }

  public onRowsChanged(pagedData: IPagedDataTable<ProductTableRow>) {
    this.totalCount = pagedData.totalNumberOfRecords;
  }

  cancel() {
    this.dialogRef.close(null);
  }

  public onRowChanged(rowChanges: RowChanges) {
    this.selectedProducts = rowChanges.modifiedRows.filter(product => product.selected === true);
  }

  public save(row?: ProductTableRow) {
    this.dialogRef.close(row ? row : this.selectedProducts);
  }
}
